import { BaseMutationTypes } from '../BaseMutationTypes';

export class AutomotiveWorkflowJobMutationTypes extends BaseMutationTypes {
  public static readonly SetIsManufacturerTabLoading = 'SET_IS_MANUFACTURER_TAB_LOADING';
  public static readonly ManufacturerTabLoaded = 'MANUFACTURER_TAB_LOADED';
  public static readonly ManufacturerTabError = 'MANUFACTURER_TAB_ERROR';
  public static readonly UpdateManufacturerDataSourceFieldValue = 'UPDATE_MANUFACTURER_DATA_SOURCE_FIELD_VALUE';
  public static readonly UnloadAutomotiveWorkflowJob = 'UNLOAD_AUTOMOTIVE_WORKFLOW_JOB';
}
